import { CommonActions } from '@react-navigation/routers'
import type { NavigationAction } from '@react-navigation/routers'

const appFlowReset = Symbol('appFlowReset')

// Explicit flow transitions may replace protected screens without disabling back protection.
export const createAppFlowReset = (
  state: Parameters<typeof CommonActions.reset>[0],
  target: string
) => ({
  ...CommonActions.reset(state),
  target,
  [appFlowReset]: true,
})

// React Navigation copies actions before emitting beforeRemove; symbol properties survive.
export const isAppFlowReset = (action: NavigationAction) =>
  action.type === 'RESET' &&
  appFlowReset in action &&
  action[appFlowReset] === true
